/**
 * @fileoverview Component for the License Assignment summary table, with a row for Select Features.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */

import {FeatureSelection} from '/src/com/yext/listingslaunchstorm/js/enterprise/selectfeatures/data/featureselection';
import {ViewStepButton} from '/src/com/yext/listingslaunchstorm/js/enterprise/summary/viewstepbutton';
import {EnterpriseConfiguration} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/enterpriseconfiguration';
import {TaskIds} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/taskids';
import {Table} from '/ui/components/table/table';

const COLUMN_IDS = {
  STEP: 'step',
  COUNT: 'count',
  SELECTION: 'selection',
  ACTION: 'action',
};

/**
 * @param {{
 *   enterpriseConfiguration: EnterpriseConfiguration,
 *   onViewStep: function(string): void,
 * }} props
 * @returns {React.ReactNode}
 */
export function LicenseAssignmentTable({
  enterpriseConfiguration,
  onViewStep,
}) {
  return (
    <Table
      label={yext.msg('Summary of completed License Assignment steps')}
      columns={getColumns()}
      dataRows={getRows(enterpriseConfiguration, onViewStep)}
    />
  );
}

/** @returns {!Array<?>} !Array<Table.Types.Column> */
function getColumns() {
  return [
    {
      id: COLUMN_IDS.STEP,
      label: yext.msg('Step'),
    },
    {
      id: COLUMN_IDS.COUNT,
      label: yext.msg('Count'),
    },
    {
      id: COLUMN_IDS.SELECTION,
      label: yext.msg('Selection'),
    },
    {
      id: COLUMN_IDS.ACTION,
      label: undefined,
    },
  ];
}

/**
 * @param {EnterpriseConfiguration} enterpriseConfiguration
 * @param {function(string): void} onViewStep
 * @returns {!Array<?>} !Array<Table.Types.Row>
 */
function getRows(enterpriseConfiguration, onViewStep) {
  return [
    {
      id: 'selectfeatures',
      [COLUMN_IDS.STEP]: yext.msg('Select Features'),
      [COLUMN_IDS.COUNT]: !enterpriseConfiguration.featureSelection?.skipSetup ? enterpriseConfiguration.featureSelection?.ids?.length || 0 : 0,
      [COLUMN_IDS.SELECTION]: getSelectFeaturesContent(enterpriseConfiguration.featureSelection, enterpriseConfiguration.featureSelection?.skipSetup ?? false),
      [COLUMN_IDS.ACTION]: (<ViewStepButton onClick={() => onViewStep(TaskIds.SELECT_FEATURES)} />),
    },
  ];
}

/**
 * @param {FeatureSelection | undefined} featureSelection
 * @param {boolean} skipSetup
 * @returns {React.ReactNode}
 */
function getSelectFeaturesContent(featureSelection, skipSetup) {
  if (featureSelection && !skipSetup) {
    return (
      <ul>
        {featureSelection.displayNames.map(n => (
          <li key={n}>{n}</li>
        ))}
      </ul>
    );
  } else {
    return yext.msg('None');
  }
}
